import PortalApiService from './PortalApiService';
import { FACILITY_LOGIN_URL } from './apiConfig';

// Auth for the company / facility portal. Stored separately from the admin session.
class PortalAuthService {

  async login(email, password) {
    const response = await PortalApiService.request({
      method: 'POST',
      url: '/login',
      data: { email, password },
    });
    return response.data;
  }

  async logout() {
    try {
      await PortalApiService.request({ method: 'POST', url: '/logout' });
    } catch (error) {
      // Token may already be invalid; clear the session regardless
    }
    localStorage.removeItem('company');
    window.location.href = FACILITY_LOGIN_URL;
  }

  getCurrentUser() {
    try {
      return JSON.parse(localStorage.getItem('company'));
    } catch (error) {
      return null;
    }
  }

  setCurrentUser(company) {
    localStorage.setItem('company', JSON.stringify(company));
  }

  isFacility() {
    return this.getCurrentUser()?.type === 'facility';
  }
}

const portalAuthServiceInstance = new PortalAuthService();
export default portalAuthServiceInstance;
